<div *ngIf="isNoDevicesMode" class="device-dropdown-disabled">
  <span>{{'COMMON.DEVICE_OVERVIEW' | translate}}</span>
  <app-svg-icon [name]="'chevron-down'" class="arrow-icon" style="margin-top:3px"></app-svg-icon>
</div>

<app-responsive-dropdown-scaffold *ngIf="!isNoDevicesMode" [(ngModel)]="selectedDevice" #dropdownScaffold (ngModelChange)="onSelectionChange()">
  <div dropdown [ngClass]="{open: dropdownScaffold.panelOpen}" class="device-dropdown" [title]="isOverviewMode ? ('COMMON.DEVICE_OVERVIEW' | translate) : getSelectedItemText()">

    <!-- Overview mode: show "Alle Geräte" as trigger -->
    <div *ngIf="isOverviewMode" class="d-flex overflow-hidden">
      <app-svg-icon [name]="'sitemap'" class="device-icon"></app-svg-icon>
      <span class="device-dropdown-trigger-text overflow-hidden text-nowrap">
        {{'COMMON.DEVICE_OVERVIEW' | translate}}
      </span>
      <span class="device-dropdown-trigger-text-narrow text-truncate">
        {{'COMMON.DEVICE_OVERVIEW' | translate}}
      </span>
    </div>

    <!-- Device mode: show active device -->
    <ng-container *ngIf="!isOverviewMode">
      <div *ngIf="selectedDevice; else dropdownLoading" class="d-flex overflow-hidden">
        <app-svg-icon [name]="selectedDevice.device.type === DeviceType.CB ? 'mobile-alt' : 'desktop'" class="device-icon"></app-svg-icon>
        <span class="device-dropdown-trigger-text overflow-hidden text-nowrap">
          <span *ngIf="selectedDevice.username != null" class="text-truncate">{{selectedDevice.username}}</span>
          <span *ngIf="selectedDevice.username != null" class="flex-shrink-0">&nbsp;–&nbsp;</span>
          <span class="text-truncate">{{selectedDevice.device.name}}</span>
        </span>
        <span class="device-dropdown-trigger-text-narrow text-truncate">
          {{getSelectedItemText()}}
        </span>
      </div>
      <ng-template #dropdownLoading>
        <app-spinner class="device-dropdown-spinner"></app-spinner>
      </ng-template>
    </ng-container>
    <app-svg-icon [name]="'chevron-down'" class="arrow-icon" style="margin-top:3px"></app-svg-icon>
  </div>

  <!-- Dropdown content -->
  <div dropdown-content #itemContainer class="device-dropdown-content">

    <!-- #DEV26 OVERVIEW: deaktiviert bis deploy bereit — ng-container auf true setzen zum Aktivieren -->
    <ng-container *ngIf="true">
      <button *ngIf="!isOverviewMode" class="ddc-all-devices-btn" type="button" (click)="onAllDevicesClick()">
        <span class="label label-all-devices"><app-svg-icon [name]="'sitemap'"></app-svg-icon></span>
        <span class="name-container">{{'COMMON.DEVICE_OVERVIEW' | translate}}</span>
      </button>
      <hr *ngIf="!isOverviewMode" class="ddc-divider">

      <div *ngIf="isOverviewMode" class="ddc-all-devices-active">
        <span class="label label-all-devices"><app-svg-icon [name]="'sitemap'"></app-svg-icon></span>
        <span class="name-container">{{'COMMON.DEVICE_OVERVIEW' | translate}}</span>
      </div>
      <hr *ngIf="isOverviewMode" class="ddc-divider">
    </ng-container>

    <ng-container *ngFor="let items of dropdownItems">
      <!-- Device without users -->
      <app-dropdown-item *ngIf="items.length === 1 && items[0].username == null"
        class="option"
        [title]="items[0].device.name"
        [value]="items[0]"
      >
        <span *ngIf="items[0].device.name!=='UNKNOWN'" class="label label-mobile">
          <app-svg-icon [name]="'mobile-alt'" style="margin-left:5px"></app-svg-icon>
        </span>

        <span *ngIf="items[0].device.name==='UNKNOWN'" class="label label-warning">
        <app-svg-icon [name]="'exclamation-triangle'" style="color:white"></app-svg-icon>
        </span>

        <span class="name-container">{{items[0].device.name}}</span>
      </app-dropdown-item>

      <!-- Use itemgroup if we have a device with users which means, the users instead of the device must be selected -->
      <app-dropdown-itemgroup *ngIf="items.length >= 1 && items[0].username != null" class="option-group">
        <app-dropdown-itemgroup-label [title]="items[0].device.name" class="option-group-label">
          <span class="label label-desktop">
            <app-svg-icon [name]="'desktop'"></app-svg-icon>
          </span>
          <span class="name-container">
            {{items[0].device.name}}
          </span>
          <span>
            <div class="user-count-box">
              {{items.length}} {{'HEADER.DEVICE_DROPDOWN_USERS' | translate}}
            </div>-
          </span>
        </app-dropdown-itemgroup-label>
        <app-dropdown-item *ngFor="let item of items"
          class="option"
          [title]="item.username"
          [value]="item"
        >
          <span class="label label-user">
            <app-svg-icon [name]="'user'"></app-svg-icon>
          </span>
          <span class="name-container">
            {{item.username}}
          </span>
        </app-dropdown-item>
      </app-dropdown-itemgroup>
    </ng-container>
  </div>
</app-responsive-dropdown-scaffold>

